// /opt/isp_erp/frontend/src/pages/ftth/Reports.jsx
import React, { useState, useEffect } from 'react';
import { Container, Typography, Paper, Grid, Card, CardContent, Box, CircularProgress, Alert } from '@mui/material';
import { ftthAPI } from '../../api/ftth.api';

const Reports = () => {
  const [naps, setNaps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    cargarNaps();
  }, []);

  const cargarNaps = async () => {
    setLoading(true);
    try {
      const data = await ftthAPI.getNaps();
      setNaps(data);
    } catch (error) {
      setError('Error al cargar datos');
    } finally {
      setLoading(false);
    }
  };

  const totalPuertos = naps.reduce((sum, n) => sum + n.capacidad_puertos, 0);
  const totalOcupados = naps.reduce((sum, n) => sum + n.puertos_ocupados, 0);
  const totalLibres = naps.reduce((sum, n) => sum + n.puertos_libres, 0);
  const porcentajeGlobal = totalPuertos > 0 ? (totalOcupados / totalPuertos) * 100 : 0;

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h4" gutterBottom>📊 Reportes FTTH</Typography>
      {loading ? <CircularProgress /> : error ? <Alert severity="error">{error}</Alert> : (
        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <Card><CardContent><Typography color="text.secondary">Total NAPs</Typography><Typography variant="h4">{naps.length}</Typography></CardContent></Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card><CardContent><Typography color="text.secondary">Puertos Totales</Typography><Typography variant="h4">{totalPuertos}</Typography></CardContent></Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card sx={{ bgcolor: '#fff3e0' }}><CardContent><Typography color="text.secondary">Puertos Ocupados</Typography><Typography variant="h4" color="warning.main">{totalOcupados}</Typography></CardContent></Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card sx={{ bgcolor: '#e8f5e9' }}><CardContent><Typography color="text.secondary">Puertos Libres</Typography><Typography variant="h4" color="success.main">{totalLibres}</Typography></CardContent></Card>
          </Grid>
          <Grid item xs={12}>
            <Card><CardContent><Typography variant="h6">Ocupación Global: {porcentajeGlobal.toFixed(1)}%</Typography><Box sx={{ width: '100%', height: 20, bgcolor: '#e0e0e0', borderRadius: 10, overflow: 'hidden', mt: 1 }}><Box sx={{ width: `${porcentajeGlobal}%`, height: '100%', bgcolor: porcentajeGlobal >= 90 ? '#f44336' : porcentajeGlobal >= 70 ? '#ff9800' : '#4caf50' }} /></Box></CardContent></Card>
          </Grid>
        </Grid>
      )}
    </Container>
  );
};

export default Reports;
